module.exports = __webpack_public_path__ + "media/assets/images/icons/share-icon-5faacb69ea296fea4b13780d069caef3.svg";